<script>
    import {QuestionType} from '../../Element/constants.js';
    import NumberInput from '../../NumberInput.svelte';
    import ComboSelect from '../../ComboSelect/ComboSelect.svelte';
    import TextInput from '../../TextInput.svelte';
    import {sgettext} from '../../../i18n.js';

    export let onChange = () => {};
    export let row = null;
    export let schema = {}
    export let predefinedSelectionOptions = [];
    export let inspectionRangeOptions = [];
    export let inspectionSelectionOptions = [];
    export let editable = true;
    export let damageGroupOptions = null;
    
    function handleColumnChange(event) {
        onChange(event, row);
    }

    function renderPredefinedSelectionDisplay(predefinedSelection){
        let options = predefinedSelection.predefined_selections.map(s => s.selection_name).join(', ');
        let display = `${predefinedSelection.name} - ${options}`;

        return display;
    }

    function renderInspectionSelectionDisplay(predefinedSelection){
        let options = predefinedSelection.predefined_selections.map(s => s.selection_name).join(', ');
        let display = `${predefinedSelection.name} - ${options}`;

        return display;
    }

    function renderInspectionRangeDisplay(predefinedSelection){
        let options = predefinedSelection.predefined_selections.map(s => s.selection_name).join(', ');
        let display = `${predefinedSelection.name} - ${options}`;

        return display;
    }
</script>

<style>
    .range-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-gap: 16px;
    }
    input {
    height: 32px;
    width: 32px;
    margin-left: 15px;
    }
</style>

{#if row.question_type === QuestionType.text}
    <div>{sgettext('$$TEXT_1$$')}</div>
{:else if row.question_type === QuestionType.range}
    <div class="range-grid">
        <div>
        {#if editable}
            <NumberInput
                help={sgettext("$$FROM$$")}
                key="range_from"
                max={100000}
                bind:value={row.range_from}
                on:change={handleColumnChange}
                bind:isValid={row.fieldValidations.range_from.isValid}
                bind:errors={row.fieldValidations.range_from.errors}
                object={row}
                {schema}
            />
        {:else}
            {sgettext("$$FROM$$")}: {row.range_from}
        {/if}

        </div>
        <div>
        {#if editable}
            <NumberInput
                help={sgettext("$$TO$$")}
                key="range_to"
                max={100000}
                bind:value={row.range_to}
                on:change={handleColumnChange}
                bind:isValid={row.fieldValidations.range_to.isValid}
                bind:errors={row.fieldValidations.range_to.errors}
                object={row}
                {schema}
            />
        {:else}
            {sgettext("$$TO$$")}: {row.range_to}
        {/if}
        </div>
    </div>
{:else if row.question_type === QuestionType.number}
    <div>{sgettext('$$NUMBER_1$$')}</div>
{:else if row.question_type === QuestionType.signature}
    <div>{sgettext('$$IMAGE_1$$')}</div>
{:else if row.question_type === QuestionType.photo}
  <div>{sgettext('$$IMAGE_1$$')}</div>
{:else if row.question_type === QuestionType.image}
    <div>{sgettext('$$IMAGE_1$$')}</div>
{:else if row.question_type === QuestionType.confirmation}
    <div>{sgettext('$$CONFIRMED$$')}</div>
{:else if row.question_type === QuestionType.selection}
    <div>
    {#if editable}
        <TextInput
            key="selection_text"
            bind:value={row.selection_text}
            on:change={handleColumnChange}
            bind:isValid={row.fieldValidations.selection_text.isValid}
            bind:errors={row.fieldValidations.selection_text.errors}
            multiline={true}
            help={sgettext("$$SELECTION_TEXT_NEEDS_PROVIDED_COMMA_LI_1$$")}
            object={row}
            {schema}
            />
    {:else}
        {row.selection_text}
    {/if}
    </div>
{:else if row.question_type === QuestionType.predefined}
    <div>
    {#if editable}
        <ComboSelect
            value={row.predefined_selection_question? row.predefined_selection_question.id : null}
            key="predefined_selection_question"
            bind:options={predefinedSelectionOptions}
            bind:selected={row.predefined_selection_question}
            on:changed={handleColumnChange}
            bind:isValid={row.fieldValidations.predefined_selection_question.isValid}
            bind:errors={row.fieldValidations.predefined_selection_question.errors}
            {schema} />
    {:else}
        {renderPredefinedSelectionDisplay(row.predefined_selection_question)}
    {/if}
    </div>
{:else if row.question_type === QuestionType.timed}
    <div>
    {#if editable}
        <NumberInput
            help={sgettext("$$TIMER_DURATION_SECONDS_1$$")}
            key="duration"
            min={1}
            max={3599}
            bind:value={row.duration}
            on:change={handleColumnChange}
            bind:isValid={row.fieldValidations.duration.isValid}
            bind:errors={row.fieldValidations.duration.errors}
            object={row}
            {schema}
        />
    {:else}
        {row.duration}
    {/if}
    </div>
{:else if row.question_type === QuestionType.inspection_selection || row.question_type === QuestionType.inspection_range }
<div class="range-grid">
        {#if row.question_type === QuestionType.inspection_range}
        <div>
            {#if editable}
                <ComboSelect
                value={row.inspection_range? row.inspection_range.id : null}
                key="inspection_range"
                bind:options={inspectionRangeOptions}
                label={sgettext("$$INSPECTION_RANGE_OPTIONS$$")}
                bind:selected={row.inspection_range}
                on:changed={handleColumnChange}
                bind:isValid={row.fieldValidations.inspection_range.isValid}
                bind:errors={row.fieldValidations.inspection_range.errors}
                {schema} />
            {:else}
                {renderInspectionRangeDisplay(row.inspection_range)}
            {/if}
        </div>
        {/if}
        {#if row.question_type === QuestionType.inspection_selection}
        <div>
            {#if editable}
                <ComboSelect
                value={row.inspection_selection? row.inspection_selection.id : null}
                key="inspection_selection"
                bind:options={inspectionSelectionOptions}
                label={sgettext("$$INSPECTION_SELECTION_OPTIONS$$")}
                bind:selected={row.inspection_selection}
                on:changed={handleColumnChange}
                bind:isValid={row.fieldValidations.inspection_selection.isValid}
                bind:errors={row.fieldValidations.inspection_selection.errors}
                {schema} />
            {:else}
                {renderInspectionSelectionDisplay(row.inspection_selection)}
            {/if}
        </div>
        {/if}   
    <div>
        {#if editable}
            <TextInput
            key="code"
            bind:value={row.code}
            on:change={handleColumnChange}
            bind:isValid={row.fieldValidations.code.isValid}
            bind:errors={row.fieldValidations.code.errors}
            label={sgettext("$$CHARACT_CODE$$")}
            object={row}
            {schema}
            />
        {:else}
        {sgettext("$$CHARACT_CODE$$")} : {row.code}
        {/if}
    </div>
    <div>
    {#if editable}
        <ComboSelect
        key="data_type"
        bind:value={row.data_type}
        on:changed={handleColumnChange}
        options={[{id:"character",name:"character"},{id:"numeric",name:"numeric"}]}
        bind:isValid={row.fieldValidations.data_type.isValid}
        bind:errors={row.fieldValidations.data_type.errors}
        label={sgettext("$$DATA_TYPE$$")}
        object={row}
        {schema}
        />
    {:else}
        {sgettext("$$DATA_TYPE$$")} : {row.data_type}
    {/if}
    </div>
    <div>
    {#if editable}
        <TextInput
        key="uom"
        bind:value={row.uom}
        on:change={handleColumnChange}
        bind:isValid={row.fieldValidations.uom.isValid}
        bind:errors={row.fieldValidations.uom.errors}
        label={sgettext("$$UOM$$")}
        object={row}
        {schema}
        />
    {:else}
        {sgettext("$$UOM$$")} : {row.uom}
    {/if}
    </div>
    <div>
    {#if editable}
        <ComboSelect
        key="damage_group_code"
        bind:value={row.damage_group_code}
        on:changed={handleColumnChange}
        options={damageGroupOptions}
        bind:isValid={row.fieldValidations.damage_group_code.isValid}
        bind:errors={row.fieldValidations.damage_group_code.errors}
        label={sgettext("$$DAMAGE_GROUP$$")}
        object={row}
        {schema}
        />

    {:else}
        {sgettext("$$DAMAGE_GROUP$$")} : {row.damage_group_name}
    {/if}
    </div>
    <div>
    {#if editable}
    {sgettext("$$OPTIONAL$$")}
    <input
        type="checkbox"
        key="optional"
        bind:checked={row.optional}
        on:change={handleColumnChange}
        label={sgettext("$$OPTIONAL$$")}
        object={row}
        {schema}
    />
    {:else}
    {sgettext("$$OPTIONAL$$")} :
    <input
        type="checkbox"
        key="optional"
        bind:checked={row.optional}
        on:change={handleColumnChange}
        object={row}
        {schema}
        disabled
    />
    {/if}
    </div>
</div>
{/if}
